import React from "react";
import Container from "../helpers/Container";
import "./jobssection.scss";
import { connect } from "react-redux";
import { fetchJobs, addLoader, removeLoader, loadMore } from "../../actions";
import CardInfo from "./CardInfo";

class JobsSection extends React.Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
  }

  onButtonClick = async () => {
    this.props.addLoader();
    if (this.props.formValues.SearchJobs.submitSucceeded) {
      this.props
        .loadMore(
          this.props.formValues.SearchJobs.values.misc,
          this.props.formValues.SearchJobs.values.location,
          this.props.formValues.SearchJobs.values.fulltime
        )
        .then(() => {
          this.props.removeLoader();
        });
    } else {
      await this.props.loadMore();
      this.props.removeLoader();
    }
  };

  render() {
    return (
      <React.Fragment>
        <section className="jobs__section">
          <Container>
            <ul className="jobs__list">
              <CardInfo buttonRef={this.buttonRef} />
            </ul>
            <button
              ref={this.buttonRef}
              className="btn center"
              onClick={this.onButtonClick}
            >
              Load More
            </button>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jobs: state.jobs,
    formValues: state.form,
    isLoading: state.loader.isLoading,
  };
};

export default connect(mapStateToProps, {
  fetchJobs,
  addLoader,
  removeLoader,
  loadMore,
})(JobsSection);
